<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="申请人:" prop="name">
                        <el-input
                        v-model="queryParams.name"
                        placeholder="请输入申请人"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="申请日期:" >
                        <el-date-picker size="small" clearable
                            v-model="queryParams.startTime"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        至
                        <el-date-picker size="small" clearable
                            v-model="queryParams.endTime"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="rwzxList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="申请人" prop="name" width="80" />
                    <el-table-column align="center" label="申请时间" prop="createTime"  width="120" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.createTime">{{getDate(scope.row.createTime,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="被处罚名称" prop="punishedPerson" width="120" />
                    <el-table-column align="center" label="案由" prop="causeOfAction"  />
                    <el-table-column align="center" label="是否合格" prop="correct" width="80" >
                        <template slot-scope="scope">
                            <el-tag size="small" :type="(scope.row.correct === 'true') ? 'success' : 'danger'">
                                {{ (scope.row.correct === 'true') ? "合格" : "不合格" }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="审核描述" prop="describe"  />
                    <el-table-column align="center" label="扣分" prop="fz" width="60" />
                    <el-table-column align="center" label="审核状态" prop="status" width="80" >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 1"  size="small" type="warning">待审核</el-tag>
                            <el-tag v-else-if="scope.row.status == 2"  size="small" type="success">已通过</el-tag>
                            <el-tag v-else-if="scope.row.status == 3"  size="small" type="danger" @click="getRemark(scope.row.remark)">已驳回</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="80" >
                        <template slot-scope="scope">
                            <el-button  v-if="scope.row.status == 1"
                                size="small"
                                type="text"
                                @click="handleShenhe(scope.row)"
                            >审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>


        <el-dialog title="评查内容审核" :visible.sync="open" width="800px" append-to-body class="newTk" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="是否通过" prop="correct">
                    <el-radio-group size="small" v-model="form.status">
                        <el-radio label="2">通过</el-radio>
                        <el-radio label="3">驳回</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="驳回原因" prop="remark">
                    <el-input size="small" :disabled="form.status=='2'?true:false" v-model="form.remark" type="textarea" :rows="5"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary"  size="small" @click="submit('form')">确 定</el-button>
                <el-button size="small" @click="open = false">取 消</el-button>
            </div>
        </el-dialog>


        <el-dialog title="任务详情" :visible.sync="open2" width="80%" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            <el-form :model="queryParams4" ref="queryForm4" :inline="true">
                <el-form-item label="市:" prop="shi">
                    <el-select size="small" clearable v-model="queryParams4.shi" @change="getXianqu">
                        <el-option v-for="(item,index) in shiOptions" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="县区:" prop="xianqu">
                    <el-select size="small" clearable v-model="queryParams4.xianqu">
                        <el-option v-for="(item,index) in xianquOptions" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务名称:" prop="title">
                    <el-input
                    v-model="queryParams4.title"
                    placeholder="请输入任务名称"
                    clearable
                    size="small"
                    @keyup.enter.native="handleQuery"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery4">查询</el-button>
                    <el-button icon="el-icon-refresh" size="small" @click="resetQuery4">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading4" :data="rwxqList">
                <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                    <template slot-scope="scope">
                        <span>{{(scope.$index+1) + ( queryParams4.limit * (queryParams4.page-1))}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="地区" prop="xianqu" width="80" />
                <el-table-column label="监督单位名称" prop="name" />
                <el-table-column label="任务名称" prop="title" />
                <el-table-column label="上传时间"  align="center" prop="createTime" width="100" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.createTime">{{getDate(scope.row.createTime,'yyyy-MM-dd')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="测评状态" align="center" prop="assessStatusName" width="80" >
                    <template slot-scope="scope">
                        <el-tag  size="small" :type="scope.row.assessStatus == '1'?'success':'info'">{{scope.row.assessStatusName}}</el-tag>
                    </template>
                </el-table-column> 
                <el-table-column label="得分" align="center" prop="score" width="80" />
                <el-table-column label="被处罚名称" align="center" prop="punishedPerson" width="160"  />
                <el-table-column label="案由" prop="causeOfAction" />
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="getPcImg(scope.row.id)">评查详情</el-button>
                        <el-button size="mini" type="text" @click="handlePcaj(scope.row.id)">查看案卷</el-button>
                        <el-button v-if="scope.row.status == 1" size="mini" type="text" @click="handlePc(scope.row)">评查</el-button>
                    </template> 
                </el-table-column>
            </el-table>
            <div class="page-part" style="padding:20px 20px 50px;">
                <el-pagination  v-if="pageshow4"
                    background
                    @size-change='handleSizeChange4'
                    @current-change='handleCurrentChange4'
                    :current-page="queryParams4.page"
                    :page-sizes="[10,20,30,40]"
                    :page-size="queryParams4.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="total4" style=" float:right;">
                </el-pagination>
            </div>
        </el-dialog>

        <el-dialog title="评查详情" :visible.sync="open5" width="1000px" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            <h3>评查得分：{{pcdf}}</h3>
            <el-table v-loading="loadingSc" :data="pcjgList">
                <el-table-column align="center" label="序号" type="index" width="60" />                
                <el-table-column align="center" label="评查指标" prop="name" />
                <el-table-column align="center" label="是否合格" prop="correct" width="80" >
                    <template slot-scope="scope">
                        <el-tag size="small" :type="(scope.row.correct === 'true') ? 'success' : 'danger'">
                            {{ (scope.row.correct === 'true') ? "合格" : "不合格" }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="审核描述" prop="describe"  />
                <el-table-column align="center" label="扣分" prop="fz" width="60" />
                <el-table-column align="center" label="评查人" prop="dmName" width="80" />
                <el-table-column align="center" label="审核人" prop="updateName" width="80" />
                <el-table-column align="center" label="审核时间" prop="updateTime"  width="120" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.updateTime">{{getDate(scope.row.updateTime,'yyyy-MM-dd')}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="查看案卷" :visible.sync="open6" width="600px" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            
            <div class="anjuan" v-loading="loadingAj">
                <!--<h3>{{ajbt}}</h3><div class="menus">
                    <el-scrollbar ref="myScrollbar">
                        <ul>
                            <li v-for="(item,index) in ajNames" :key="index" :class="isIndex == index?'active':''" @click="showWs(item,index)">
                                <p><i class="el-icon-document"></i>&nbsp;{{ item.name }}</p>
                            </li>
                        </ul>
                    </el-scrollbar>
                </div>-->
                <div class="imgW">
                    <el-scrollbar ref="myScrollbar2">
                        <p v-show="ajImgs" v-for="(item,index) in ajImgs" :key="index">
                            <img :src="item" @dblclick="showBig(item)" />
                        </p>
                        <!--<el-button type="text" size="small" v-show="ajImgs[isIndex]" @click="showText(1)" style="position: absolute; top: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">相关参数</el-button>-->
                    </el-scrollbar>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="案卷文书" :visible.sync="openBig" top="20px" :width="isH?'700px':'1200px'" append-to-body ref="rotate"  :close-on-click-modal="false">
            <div style="text-align: right; margin-right: 40px;  position: absolute; right: 10px; top: 8px;">
            <el-button type="warning" size="small" @click="rotate">旋转</el-button></div>
            <!--<p v-show="bigSrcs" v-for="(item,index) in bigSrcs" :key="index" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;">
                <img :src="item" style="width: 100%;" />
            </p>-->
            <p v-show="bigSrc" ref="rotate" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;"><img :src="bigSrc"  style="width: 100%;" /></p>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            queryParams:{
                name:'',
                startTime:'',
                endTime:'',
                page:1,
                limit:10,
            },
            total:0,
            rwzxList:[],
            ztOptions:[],
            open:false,
            pageshow:true,
            dm: '',
            cmid:'',
            sc: "",
            xg: "",
            xz: "",
            yhsfId: '',
            form:{
                id: '',
                status: '2', // 响应式字段必须提前声明
                remark: ''
            },
            rules:{},
            loading2: false,
            loading3: false,
            ylqList: [],
            wlqList: [],
            activeName: 'first',
            queryParams2:{
                name: '',
                page:1,
                limit:10
            },
            queryParams3:{
                name: '',
                page:1,
                limit:10
            },
            total2:0,
            total3:0,
            pageshow2:true,
            pageshow3:true,
            lqId: '',
            open2:false,
            queryParams4:{
                page:1,
                limit:10,
                shi: '全部',
                xianqu:'全部',
                title:''
            },
            rwxqList:[],
            total4:0,
            loading4:false,
            pageshow4:true,
            xqId:'',
            shiOptions: [],
            xianquOptions:[],
            loadingSc: false,
            loading5:false,
            open5:false,
            pcdf: 0,
            zfs: 0,
            pcjgList:[],
            open6:false,
            ajbt:'',
            ajNames:[],
            ajImgs:[],
            isIndex:0,
            loadingAj: false,
            openBig: false,
            bigSrc: '',
            isH: false,
            deg:0,
            loadingPc: false,
            baseUrl:''
        };
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        //console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '审核管理'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.yhsfId = user.yhsfId
        this.baseUrl = user.baseUrl
        this.getList()
        this.getShi()
    },
    methods: {
        async getList(){
            this.rwzxList = []
            this.total = 0
            
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/auditsManagement`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    name:this.queryParams.name,
                    startTime:this.queryParams.startTime,
                    endTime:this.queryParams.endTime,
                    pageSize:this.queryParams.limit,
                    pageNum:this.queryParams.page
                }
            })
            .then(response => {
                //console.log(response.data);
                this.rwzxList = response.data.data.list
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                console.error('There was an error!', error);
            });
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        resetQuery(){
            this.queryParams = {
                name:'',
                startTime:'',
                endTime:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleShenhe(row){
            this.form.id = row.id
            this.form.remark = ''
            this.open = true  
        },
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    console.log(this.form,864)
                    axios({
                        method: 'post',
                        url: `https://xxswj.hzxhykj.com:9086/system/release/auditsByRejecting`,
                        headers: { // 添加请求头
                            "Content-Type": "application/json" // 明确声明为 JSON 格式
                        },
                        data: {
                            id: this.form.id,
                            dm: this.dm,
                            status:this.form.status,
                            remark:this.form.remark,
                        }
                    })
                    .then(response => {
                        console.log(response);
                        this.getList()
                        this.open = false
                    })
                    .catch(error => {
                        this.open = false
                        console.error('There was an error!', error);
                    });
                }
            })
        },


        handleSizeChange2(val){
            this.queryParams2.limit = val
            this.getYlq(this.lqId)
        },
        handleCurrentChange2(val){
            this.pageshow2 = false;
            this.queryParams2.page = val
            this.getYlq(this.lqId)
            this.$nextTick(() => {
                this.pageshow2 = true;
            });
        },
        handleSizeChange3(val){
            this.queryParams3.limit = val
            this.getWlq(this.lqId)
        },
        handleCurrentChange3(val){
            this.pageshow3 = false;
            this.queryParams3.page = val
            this.getWlq(this.lqId)
            this.$nextTick(() => {
                this.pageshow3 = true;
            });
        },
        handleSizeChange4(val){
            this.queryParams4.limit = val
            this.getXq(this.xqId)
        },
        handleCurrentChange4(val){
            this.pageshow4 = false;
            this.queryParams4.page = val
            this.getXq(this.xqId)
            this.$nextTick(() => {
                this.pageshow4 = true;
            });
        },
        handleQuery4(){
            this.pageshow4 = false;
            this.queryParams4.page = 1
            this.getXq(this.xqId)
            this.$nextTick(() => {
                this.pageshow4 = true;
            });
        },
        resetQuery4(){
            this.queryParams4 = {
                page:1,
                limit:10,
                title:'',
                xianqu:'全部',
                shi:'全部',
            }
            this.getXq(this.xqId)
        },
        handleAll(id){
            this.open2 = true;
            this.xqId = id
            this.rwxqList = []
            this.queryParams4 = {
                page:1,
                limit:10,
                title:'',
                xianqu:'全部',
                shi:'全部',
            }
            this.getXq(id)
        },
        getShi(){
            this.shiOptions = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/shi`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
            })
            .then(response => {
                //console.log(response);
                this.shiOptions = response.data.data
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getXianqu(){
            this.xianquOptions = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/xianqu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    name: this.queryParams4.shi
                }
            })
            .then(response => {
                console.log(response);
                this.xianquOptions = response.data.data
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getXq(id){
            console.log(this.xqId, this.queryParams4.title, this.queryParams4.xianqu)
            this.loading4 = true
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/detailsList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                    title:this.queryParams4.title,
                    shi:this.queryParams4.shi,
                    xianqu:this.queryParams4.xianqu,
                    pageSize:this.queryParams4.limit,
                    pageNum:this.queryParams4.page
                }
            })
            .then(response => {
                console.log(response);
                this.rwxqList = response.data.data.list
                this.total4 = response.data.data.total
                this.loading4 = false
            })
            .catch(error => {
                this.loading4 = false
                console.error('There was an error!', error);
            });
        },
        handleRemove(id){
            this.$confirm("此操作将永久删除该未发布任务, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: `https://xxswj.hzxhykj.com:9086/system/release/releasedDel`,
                    headers: { // 添加请求头
                        "Content-Type": "application/json" // 明确声明为 JSON 格式
                    },
                    data: {
                        id: id
                    }
                })
                .then(res => {
                    console.log(res,345)
                    this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.getList()
                })   
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });		
        },
        handlePc(row){
            this.loading5 = true
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/taskEvaluation`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: row.id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.getPcImg(row.id)
                    this.getXq(this.xqId)
                    this.loading5 = false
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
                //this.pcsrc = response.data.data
                this.loading5 = false
            })
            .catch(error => {
                this.loading5 = false
                console.error('There was an error!', error);
            });
        },
        getPcImg(id){ 
            this.pcjgList = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/evaluationResult`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.open5 =  true
                    this.pcjgList = response.data.data.evaluationResultResList
                    this.pcdf = response.data.data.sumFz || 0
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        handlePcaj(id){
            this.open6 = true
            this.loadingAj = true
            this.ajImgs = []
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/viewCaseFile`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.ajImgs = response.data.data.imgList
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
                this.loadingAj = false
            })
            .catch(error => {
                this.loadingAj = false
                console.error('There was an error!', error);
            });
        },
        showBig(src){
            this.bigSrc = src
            this.openBig = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        // 旋转图片
        rotate () {
            this.isH = false
            this.deg += 90
            if (this.deg >= 360) {
                this.deg = 0
            }
            this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`
        },
    }
}
</script>


<style scoped>
.anjuan{ width:100%; overflow:hidden; height:80vh;}
.menus{ width: 200px;  height: calc(100% - 45px); float: left;}
.anjuan >>> .el-scrollbar { width: 100%; height: 100%;}
.anjuan >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.anjuan >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.anjuan >>> .el-scrollbar__view{min-height: 100%;}
.anjuan .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.anjuan h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.anjuan ul{width: 180px;margin-right: 10px;padding-bottom: 10px}
.anjuan ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.anjuan ul li.active{color:#1890ff;}
.imgW{width: 100%;  height: calc(100% - 45px);float: right;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}
</style>